import { SidePanel } from "panels/content/side-panel/SidePanel"
import { LeftPanelConfig } from "./LeftPanelContext"
import { FC } from "react"

interface LeftPanelControllerProps {
    config: LeftPanelConfig | undefined
}

const LeftPanelController: FC<LeftPanelControllerProps> = ({ config }) => {
    if (config?.Item) {
        return <config.Item />
    }
    return <SidePanel />
}

export { LeftPanelController }
